import type { SnakeCasedPropertiesDeep } from 'type-fest';
import type { tellerscript } from '~/infra/api/rpc';

export enum FontSize {
  FONT_SIZE_MEDIUM = 'FONT_SIZE_MEDIUM',
  FONT_SIZE_SMALL = 'FONT_SIZE_SMALL',
  FONT_SIZE_LARGE = 'FONT_SIZE_LARGE',
  FONT_SIZE_X_SMALL = 'FONT_SIZE_X_SMALL',
  FONT_SIZE_X_LARGE = 'FONT_SIZE_X_LARGE',
}

export enum Type {
  TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
  TYPE_CHAT = 'TYPE_CHAT',
  TYPE_TALK = 'TYPE_TALK',
}

export enum TextAlign {
  TEXT_ALIGN_UNSPECIFIED = 'TEXT_ALIGN_UNSPECIFIED',
  TEXT_ALIGN_LEFT = 'TEXT_ALIGN_LEFT',
  TEXT_ALIGN_RIGHT = 'TEXT_ALIGN_RIGHT',
  TEXT_ALIGN_CENTER = 'TEXT_ALIGN_CENTER',
}

export type Character = SnakeCasedPropertiesDeep<tellerscript.ICharacter>;
export type Op = SnakeCasedPropertiesDeep<tellerscript.IOp>;
export type RGBAColor = SnakeCasedPropertiesDeep<tellerscript.IRGBAColor>;
export type Scene = SnakeCasedPropertiesDeep<tellerscript.IScene>;
